var exports = {
  "SF": "AutocompleteEmoji.module__sectionHeading___dnpSZW",
  "yF": "AutocompleteEmoji.module__divider___dnpSZW",
  "mI": "AutocompleteEmoji.module__emojiIcon___dnpSZW",
  "M9": "AutocompleteEmoji.module__stickerIconWrapper___dnpSZW",
  "F1": "AutocompleteEmoji.module__memeIconWrapper___dnpSZW",
  "lA": "AutocompleteEmoji.module__stickerIcon___dnpSZW",
  "Cu": "AutocompleteEmoji.module__memeIcon___dnpSZW",
  "_Q": "AutocompleteEmoji.module__memeVideo___dnpSZW",
  "BN": "AutocompleteEmoji.module__audioIconWrapper___dnpSZW",
  "iw": "AutocompleteEmoji.module__audioIcon___dnpSZW",
};

module.exports = exports;
